<div class="text-white text-center">
  <!-- Large screens -->
  <i *ngIf="!mobileView" class="pi pi-bell text-white noti-icon" type="button"
    (click)="getNotifications(); notificationOP.toggle($event)">
    <div *ngIf="notificationUnreadCount" class="noti-count">
      {{ notificationUnreadCount }}
    </div>
  </i>
  <!-- Small Screens -->
  <i *ngIf="mobileView" class="pi pi-bell text-white noti-icon" 
    routerLink="/{{arabicLang ? 'ar' : 'en'}}/settings/notification">
    <div *ngIf="notificationUnreadCount" class="noti-count">
      {{ notificationUnreadCount }}
    </div>
  </i>
  <p-overlayPanel #notificationOP>
    <ul class="notification-list m-0 list-unstyled" (click)="notificationOP.toggle($event)">
      <div class="head"><span>{{'navbar.notifications.title' | translate }}</span><button
          routerLink="/{{arabicLang ? 'ar' : 'en'}}/settings/notification"
          class="see-all">{{'navbar.notifications.seeAll' | translate }}</button></div>
      @if (!isLoading) {
      <li *ngFor="let item of notifications" routerLink="/{{arabicLang ? 'ar' : 'en'}}/settings/notification">
        <div class="notification">
          <div class="noti-head">
            <div class="title">{{ item.title[arabicLang ? 'ar' : 'en'] }}</div>
            <strong><small><div class="date">{{ item.createdAt! | agoOfDate }}</div></small></strong>
          </div>
          <div class="noti-body">
            <div class="content">{{item.content[arabicLang ? 'ar' : 'en'] | trimString : 40}}</div>
            <div class="status" *ngIf="!item.isRead"> <img loading="lazy" src="assets/images/navbar/new.svg"
                alt="new notification"></div>
          </div>
        </div>
      </li>
      } @else {
      <li>
        <div class="notification">
          <div class="noti-head">
            <div class="title"><p-skeleton width="100px"></p-skeleton></div>
            <div class="date"><p-skeleton width="60px"></p-skeleton></div>
          </div>
          <div class="noti-body">
            <div class="content"><p-skeleton width="150px"></p-skeleton></div>
            <div class="status"> <p-skeleton width="70px" height="25px" borderRadius="6px"></p-skeleton></div>
          </div>
        </div>
      </li>
      <li>
        <div class="notification">
          <div class="noti-head">
            <div class="title"><p-skeleton width="100px"></p-skeleton></div>
            <div class="date"><p-skeleton width="60px"></p-skeleton></div>
          </div>
          <div class="noti-body">
            <div class="content"><p-skeleton width="150px"></p-skeleton></div>
            <div class="status"> <p-skeleton width="70px" height="25px" borderRadius="6px"></p-skeleton></div>
          </div>
        </div>
      </li>
      }
    </ul>
  </p-overlayPanel>

</div>